import React, { SetStateAction } from "react";
import "react-phone-number-input/style.css";
import "app/styles/phone.scss";
import PhoneInput, { getCountries } from "react-phone-number-input";
import { concatClassnames } from "shared/utils/concatClassnames";

interface PhoneProps {
  value: string;
  onChange: SetStateAction<any>;
  id: string;
  error?: boolean;
  classList?: string;
  etc?: any;
}

const Phone: React.FC<PhoneProps> = ({
  value,
  onChange,
  id,
  error,
  classList = "",
  ...etc
}) => {
  const availableCountries = ["NL"];
  const countries = getCountries().filter((country) => {
    return availableCountries.includes(country);
  });

  return (
    <div>
      <PhoneInput
        className={concatClassnames(
          "gg-border gg-rounded-sm gg-bg-white gg-text-xs gg-text-black gg-border-dark-blue-500",
          "disabled:gg-bg-slate-50 disabled:gg-text-slate-500 disabled:gg-border-slate-200",
          error ? "gg-border-red-700" : "",
          classList
        )}
        countries={countries}
        onCountryChange={() => {}}
        defaultCountry="NL"
        placeholder="+31 "
        id={id}
        value={value}
        limitMaxLength={true}
        onChange={onChange}
        {...etc}
      />
    </div>
  );
};

export default Phone;
